<template>
  <div class="data_brain_wrap">
    <div class="brain_title">云展览一览</div>
    <div class="brain_desc">3D空间漫游，虚拟云展厅</div>

	<div class="repost_tag_wrap">
	  <span>行业分类：</span>
	  <!-- <Tag color="blue" checkable :checked="tag.isSelect" size="large" v-for="(tag, index) in tagList" :key="index"
	    :name="index" @on-change="changeSelectTag">{{ tag.txt }}</Tag> -->
		<div class="radio-group">
			<div
			  v-for="item in categoryList"
			  :key="item"
			  class="radio-btn"
			  :class="{ active: activeKey === item.id }"
			  @click="onChange(item.id)"
			>
				{{ item.name }}
			</div>
		</div>
	</div>

    <el-row class="card_wrap" type="flex">
      <el-col
        class="brain_item"
        :lg="7"
        :sm="11"
        :xs="11"
        v-for="(item, index) in cardList"
        :key="index"
		
      >
        <div class="item_title">{{ item.title }}</div>
		<div class="item_cover">
			<img :src="item.cover"/>
		</div>
        <!-- <div class="item_desc">{{ item.desc }}</div> -->
        <div class="item_navigate" @click="handleViewExhibition(item.id, item.exhibition_id)">了解详情 >></div>
        <div class="item_bg" @click="handleViewExhibition(item.id, item.exhibition_id)"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getSearch, getDataSearch } from '@/api/exhibition'
import { getCategory } from '@/api/category'
export default {
  data() {
    return {
		categoryList: [{id: 0, name: '全部'}],
		activeKey: 0,
		cardList:[]
    }
  },
  mounted(){
	  this.getExhibitiondata();
	  this.getCategory();
  },
  methods:{
	async getCategory(){
		let res = await getCategory()
		let List = res.data ? res.data : [];
		let categoryList = JSON.parse(JSON.stringify(List));
		categoryList.unshift({id:0, name: '全部'})
		this.categoryList = categoryList;
	},
    onChange(cateId){
	   getDataSearch({examine: 2, status: 1, from: 'member', category_id: cateId}).then(res=>{
		   this.cardList = res.data.list;
		   this.activeKey = cateId;
		   this.$nextTick(() => {
		       	 this.$forceUpdate();
		   });
	   })
    },
	async getExhibitiondata(){
		const list = await getDataSearch({examine: 2, status: 1, from: 'member'});
		this.cardList = list.data.list;
	},
	handleViewExhibition(id, exhibition_id){
		//this.$router.push({ path: '/viewExhibition' , params: {id: id, exhibition_id:exhibition_id} })
		this.$router.push('/viewExhibition/'+id+'/'+exhibition_id).catch((v) => {})
	},
    handleNavigate(){
      this.$router.push('/production/1').catch((v) => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.data_brain_wrap {
  padding: 50px 0;
  background: #e8eef2;
  text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
    }
  }
  .repost_tag_wrap {
    width: 70%;
    height: 100px;
    background: #f4f9fc;
    margin: 50px auto;
    display: flex;
    align-items: center;
    padding: 0 30px;
  
    span {
      color: #8a989c;
      font-size: 18px;
    }
	@media screen and (max-width: 768px) {
	  width: 95%;
	  font-size: 14px;
	  span {
	    color: #8a989c;
	    font-size: 14px;
		white-space: nowrap;
	  }
	  padding: 25px 20px 15px;
	}
  }
  .radio-group { display: flex; gap: 8px; overflow-y: auto;}
  .radio-btn {
    padding: 6px 14px;
    /* border: 1px solid #ddd; */
    border-radius: 14px;
    cursor: pointer;
	margin-right: 26px;
	@media screen and (max-width: 768px) {
		margin-right: 6vw;
	}
	white-space: nowrap;
  }
  .radio-btn.active {
    background: #1677ff;
    color: #fff;
    border-color: #1677ff;
  }
  .card_wrap {
    width: 70%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-around;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
	  cursor: pointer;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40PX;
        border-radius: 10PX;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20PX;
        &:nth-child(-n+2){
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg{
        opacity: 0.3;
      }
      &:hover .item_title {
        color: #fff;
      }
      &:hover .item_desc {
        color: #fff;
      }
      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
	  .item_cover img{
		  width: 100%;
	  }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110PX;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_navigate {
        width: 100PX;
        height: 30PX;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10PX;
          font-size: 14px;
        }
      }
    }
  }
}
</style>